import './welcome.style.sass';
import template from './welcome.tpl.pug';
import 'common/component/logo';

class WelcomeController {
    /* @ngInject */
    constructor($state) {
        this.$state = $state;
    }

    startQuiz() {
        this.onSubmit({ questionKey: 'started', answer: true });
        this.$state.go('conversion-quiz.struggles');
    }
}

export default {
    bindings: {
        onSubmit: '&'
    },
    template: template(),
    controller: WelcomeController
};



// WEBPACK FOOTER //
// ./src/presentation/scene/conversion-quiz/steps/welcome/welcome.cmpt.js